import cta from '~/components/atoms/a-ctas/a-cta-v2.data'
import card from '~/components/molecules/m-cards/m-card.data'

export default {
  heading: 'News.',
  cta: [
    {
      ...cta,
      copy: 'View all',
      href: {
        url: '/articles',
        cached_url: '/articles',
      },
      type: 'primary',
    },
  ],
  collection: [
    {
      ...card,
      image: {
        alt: 'Entry image.',
        filename:
          '//a.storyblok.com/f/46530/3375x2250/9da4b2da04/fusion-medical-animation-eaggqoiddmg-unsplash.png',
      },
      cta: [
        {
          ...cta,
          copy: 'Read Article',
          type: 'secondary',
        },
      ],
    },
    {
      ...card,
      image: {
        alt: 'Entry image.',
        filename:
          '//a.storyblok.com/f/46530/4195x2802/0bd806df69/joshua-sortino-lqkhndzsf-8-unsplash-1.jpg',
      },
      cta: [
        {
          ...cta,
          copy: 'Read Article',
          type: 'secondary',
        },
      ],
    },
    {
      ...card,
      image: {
        alt: 'Entry image.',
        filename:
          '//a.storyblok.com/f/46530/1250x833/1b6066c1de/tribal_edit_v3-00_08_23_04-still023.png',
      },
      cta: [
        {
          ...cta,
          copy: 'Read Article',
          type: 'secondary',
        },
      ],
    },
  ],
  component: 'o-news-listing',
}
